import { bestFlowProvider } from './best-flow';
import { googleAnalyticsProvider } from './google-analytics';
import type { ViewsProviderMeta } from './types';

export type { ViewsProviderMeta } from './types';

/** Fontes de visitas oferecidas ao tenant, na ordem em que aparecem. */
export const viewsProviders: ViewsProviderMeta[] = [bestFlowProvider, googleAnalyticsProvider];

export const getViewsProviderById = (id: string): ViewsProviderMeta | undefined =>
  viewsProviders.find((p) => p.id === id);
